export default "__VITE_ASSET__C5dkQP8F__"